import { Injectable } from '@angular/core';
import { RidangoEpic } from '@ridango/core';
import { PurchaseActions, PurchaseService } from '@ridango/components';
import { ActionsObservable } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PurchaseEpic implements RidangoEpic {
    constructor(
        private actions: PurchaseActions,
        private service: PurchaseService
    ) {}

    register() {
        return [this.fetchCategoryProductDetails];
    }

    fetchCategoryProductDetails = (action$: ActionsObservable<any>) =>
        action$.ofType(PurchaseActions.FETCH_CATEGORY_PRODUCT_DETAILS).pipe(
            switchMap((action) => {
                return this.service.getCategoryProductDetails().pipe(
                    map((response) => this.actions.handleCategoryProductDetailsSuccess(response)),
                    catchError((error) => {
                        return of(this.actions.handleCategoryProductDetailsFailed(error));
                    })
                );
            })
        );
}
